import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { ASSETS, HERO } from "@/data/site";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Hero = () => {
  return (
    <section
      id="start"
      className="relative min-h-screen flex items-center justify-center overflow-hidden pt-24 pb-16"
      style={{
        background:
          "radial-gradient(120% 90% at 50% 15%, #FBEEDD 0%, #F7E6D9 35%, #F3E0D2 100%)",
      }}
    >
      {/* warm blush wash to match the logo background */}
      <div className="absolute inset-0 bg-[#F7E7DA]" />
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(120%_80%_at_50%_10%,rgba(255,255,255,0.6)_0%,rgba(247,231,218,0)_55%)]" />

      {/* content */}
      <div className="relative z-20 mx-auto max-w-4xl px-8 text-center flex flex-col items-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
          className="w-[19rem] sm:w-[25rem] lg:w-[33rem]"
        >
          <video
            src={ASSETS.heroVideo}
            poster={ASSETS.logo}
            autoPlay
            muted
            playsInline
            preload="auto"
            className="w-full h-auto drop-shadow-[0_25px_60px_rgba(168,139,99,0.3)]"
          />
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.8 }}
          className="mt-4 max-w-2xl text-charcoal-soft text-base sm:text-lg leading-relaxed font-light"
        >
          {HERO.welcome}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 1.1 }}
          className="mt-9 flex flex-col sm:flex-row gap-4"
        >
          <button
            data-testid="hero-cta"
            onClick={() => scrollTo("kontakt")}
            className="rounded-full bg-charcoal text-gold-soft px-9 py-4 text-sm tracking-wide hover:bg-charcoal-soft transition-colors duration-300"
          >
            Termin vereinbaren
          </button>
          <button
            data-testid="hero-secondary"
            onClick={() => scrollTo("leistungen")}
            className="rounded-full border border-gold/60 text-charcoal px-9 py-4 text-sm tracking-wide hover:bg-gold/10 transition-colors duration-300"
          >
            Leistungen entdecken
          </button>
        </motion.div>
      </div>

      <button
        onClick={() => scrollTo("ueber")}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 z-20 text-gold-deep hidden lg:flex flex-col items-center gap-2"
        aria-label="Nach unten scrollen"
      >
        <span className="text-[10px] uppercase tracking-luxe">Entdecken</span>
        <ArrowDown size={18} className="animate-bounce" />
      </button>
    </section>
  );
};
